export * from '@primeuix/themes/nora/skeleton';
export { default } from '@primeuix/themes/nora/skeleton';
